export default __webpack_public_path__ + "static/media/people7.51fdf7cd.png";